import { ref, onValue, set, remove } from "firebase/database";
import { db } from "./firebaseClient";

const BASE = (teacherId) => `cise/availability/${teacherId}`;

export function subscribeTeacherAvailability(teacherId, cb) {
    if (!teacherId) return () => { };

    const blockedDatesRef = ref(db, `${BASE(teacherId)}/blocked/dates`);
    const blockedWeeklyRef = ref(db, `${BASE(teacherId)}/blocked/weekly`);
    const bookingsRef = ref(db, `${BASE(teacherId)}/bookings`);

    const openOverridesRef = ref(db, `${BASE(teacherId)}/overrides/open`);

    let blockedDates = {};
    let blockedWeekly = {};
    let bookings = {};

    let openOverrides = {};


    const emit = () => cb({ blockedDates, blockedWeekly, openOverrides, bookings });

    const unsubOpen = onValue(openOverridesRef, (snap) => {
        openOverrides = snap.val() || {};
        emit();
    });

    const unsubDates = onValue(blockedDatesRef, (snap) => {
        blockedDates = snap.val() || {};
        emit();
    });

    const unsubWeekly = onValue(blockedWeeklyRef, (snap) => {
        blockedWeekly = snap.val() || {};
        emit();
    });

    const unsubBookings = onValue(bookingsRef, (snap) => {
        bookings = snap.val() || {};
        emit();
    });

    return () => {
        unsubDates();
        unsubWeekly();
        unsubOpen();
        unsubBookings();
    };
}

// Pontual: dates/YYYY-MM-DD/HH:MM = true
export async function setBlockedDate(teacherId, dayKey, slot, value) {
    const slotRef = ref(db, `${BASE(teacherId)}/blocked/dates/${dayKey}/${slot}`);
    if (value) return set(slotRef, true);
    return remove(slotRef);
}

// Recorrente: weekly/DOW/HH:MM = true  (0 dom .. 6 sab)
export async function setBlockedWeekly(teacherId, dow, slot, value) {
    const slotRef = ref(db, `${BASE(teacherId)}/blocked/weekly/${dow}/${slot}`);
    if (value) return set(slotRef, true);
    return remove(slotRef);
}

export async function setOpenOverride(teacherId, dayKey, slot, value) {
    const r = ref(db, `${BASE(teacherId)}/overrides/open/${dayKey}/${slot}`);
    if (value) return set(r, true);
    return remove(r);
}

export async function saveBooking(teacherId, dayKey, slot, bookingData) {
    const slotRef = ref(db, `${BASE(teacherId)}/bookings/${dayKey}/${slot}`);
    const now = Date.now();

    await set(slotRef, {
        type: "booking",
        ...bookingData,
        professorId: teacherId,
        updatedAt: now,
    });

    // garante: se tiver bloqueio pontual no mesmo slot, remove
    await setBlockedDate(teacherId, dayKey, slot, false);
    // e se tiver recorrente nesse DOW, remove também (opcional)
    const dow = new Date(dayKey).getDay();
    await setBlockedWeekly(teacherId, dow, slot, false);
}

export async function clearBooking(teacherId, dayKey, slot) {
    const slotRef = ref(db, `${BASE(teacherId)}/bookings/${dayKey}/${slot}`);
    await remove(slotRef);
}
